import React from 'react';
import useMain from '../../hooks/useMain';
import Image from './image';

function NoData({ className = undefined }) {
	const { theme } = useMain();
	return (
		<div className={`'text-center ${className}`}>
			<Image
				height='150px'
				fileName={`icons/noData_${theme}.webp`}
			/>
			<div className='fs-4 mt-4'>No Data</div>
		</div>
	);
}

export default NoData;
